import { BaseResponse } from './../generic-response';
import { DietApiService } from './diet-api.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import {
  CreatePersonalFoodParams,
  ResponseCreatePersonalFood,
  personalFood,
  deleteResponce,
  ResponseGetPersonalFood,
  ResponseGetRatioArray,
  ResponsePersonalPackages,
  Perosnlapackages,
  FoodFactCreate,
  CreatePersonalPackageParams,
} from './../../../core/model/api-response/persoanl-response-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from 'src/app/global-variables';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import {
  FoodFactModel,
  FoodFactsModel,
  FoodModel,
} from 'src/app/core/model/object/diet-food-model';

@Injectable({
  providedIn: 'root',
})
export class PersoanlService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService,
    private dbService: NgxIndexedDBService,
    private dietApiService: DietApiService
  ) {}
  getPersonalFood() {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<ResponseGetPersonalFood>(baseUrl + 'api/v2/personal/food', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        await this.saveManyFood(res);
        return new GenericResponse(
          true,
          new GenericResponseData({ getPersonalFood: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPersonalFood();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getFoodUnitId() {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<ResponseGetRatioArray[]>(baseUrl + 'api/v2/food/foodUnit', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ foodUnitId: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFoodUnitId();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  createPersonalFood(
    params: CreatePersonalFoodParams
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    if (!params.foodUnitRatioArray) {
      delete params.foodUnitRatioArray;
    }
    return this.http
      .post<ResponseCreatePersonalFood>(
        baseUrl + 'api/v2/personal/food',
        params,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        await this.saveFoodLogs(res);
        return new GenericResponse(
          true,
          new GenericResponseData({ personalFood: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.createPersonalFood(params);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  deletePersonalFood(id: string): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .delete<deleteResponce>(baseUrl + 'api/v2/personal/food/' + id, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        await this.deleteFoodLogs(id);
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deletePersonalFood(id);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }
  updatePeronalFood(
    id: string,
    params: CreatePersonalFoodParams
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    if (!params.foodUnitRatioArray) {
      delete params.foodUnitRatioArray;
    }
    return this.http
      .patch<ResponseCreatePersonalFood>(
        baseUrl + 'api/v2/personal/food/' + id,
        params,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        await this.saveFoodLogs(res);
        return new GenericResponse(
          true,
          new GenericResponseData({ personalFood: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.updatePeronalFood(id, params);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getPersonalPackage(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<ResponsePersonalPackages>(baseUrl + 'api/v2/personal/package/', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        await this.saveManyPackage(res);
        return new GenericResponse(
          true,
          new GenericResponseData({ getPersonalPackage: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPersonalFood();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  createPersonalPackage(params: CreatePersonalPackageParams) {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<{
        statusCode: number;
        package: Perosnlapackages;
        success: boolean;
      }>(baseUrl + 'api/v2/personal/package/', params, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        await this.savePersonalPackage(res['package']);
        return new GenericResponse(true);
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.createPersonalPackage(params);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  updatePersonalPackage(id: string, params: CreatePersonalPackageParams) {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .patch<{
        statusCode: number;
        package: Perosnlapackages;
        success: boolean;
      }>(baseUrl + 'api/v2/personal/package/' + id, params, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        await this.savePersonalPackage(res['package']);

        // await this.savePersonalPackage(res['package']);
        return new GenericResponse(true);
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.createPersonalPackage(params);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  removePersonalPackage(id: string): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: {
        ids: [id],
      },
    };
    return this.http
      .delete<BaseResponse>(baseUrl + 'api/v2/personal/package/', options)
      .toPromise()
      .then(async (res) => {
        await this.deletePersonalPackage(id);

        return new GenericResponse(
          res.success,
          new GenericResponseData({ BaseResponse: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.removePersonalPackage(id);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  public async saveFoodLogs(res: ResponseCreatePersonalFood): Promise<boolean> {
    const fls = await this.dbService.getByIndex(
      'personalFood',
      '_id',
      res.food._id
    );
    let response = true;
    if (fls) {
      response = await this.dbService
        .update('personalFood', {
          id: fls['id'],
          _id: res.food._id,
          foodFact: res.food.foodFact,
          name: res.food.name,
          primaryFoodUnit: res.food.primaryFoodUnit,
          foodUnitRatioArray: res.food.foodUnitRatioArray,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    } else {
      response = await this.dbService
        .add('personalFood', {
          _id: res.food._id,
          foodFact: res.food.foodFact,
          name: res.food.name,
          primaryFoodUnit: res.food.primaryFoodUnit,
          foodUnitRatioArray: res.food.foodUnitRatioArray,
        })
        .then(
          () => {
            return true;
          },
          (error) => {
            console.log(error);
            return false;
          }
        );
    }
    return Promise.resolve(response);
  }
  public async getAllFoodLogs(): Promise<personalFood[]> {
    let foodLogs: personalFood[] = [];
    const data = this.dbService.getAll('personalFood').then((fls) => {
      foodLogs = [];
      fls.forEach((food) => {
        const d = new personalFood(
          food['_id'],
          food['name'],
          food['suitableDiseases'],
          food['notSuitableDiseases'],
          food['suitableSpecialTypes'],
          food['notSuitableSpecialTypes'],
          food['seasons'],
          food['notSuitableTypes'],
          food['hatedFoods'],
          food['deleted'],
          food['primaryFoodUnit'],
          food['primaryFoodUnitCalorie'],
          food['foodFact'],
          food['foodUnitRatioArray'],
          food['createdAt'],
          food['updatedAt'],
          food['notSuitableBreastfeeding'],
          food['notSuitablePregnancy']
        );
        foodLogs.push(d);
      });
      return foodLogs;
    });

    return Promise.resolve(data);
  }
  public async deleteFoodLogs(id: string): Promise<boolean> {
    const fls = await this.dbService.getByIndex('personalFood', '_id', id);

    let response;
    if (fls) {
      response = this.dbService.delete('personalFood', fls.id).then(
        () => {
          return true;
        },
        (error) => {
          console.log(error);
          return false;
        }
      );
    } else {
      response = false;
    }
    return response;
  }
  public async saveManyFood(res: ResponseGetPersonalFood) {
    if (res.foods.length === 0) {
      return Promise.resolve(true);
    }
    if (res.deletedFoods) {
      res.deletedFoods.forEach((f) => {
        this.deleteFoodLogs(f);
      });
    }
    res.foods.forEach(async (food) => {
      if (!food.deleted) {
        const f = new ResponseCreatePersonalFood(200, food, 0, true);
        await this.saveFoodLogs(f);
      } else {
        this.deleteFoodLogs(food._id);
      }
    });
  }

  public saveManyPackage(packages: ResponsePersonalPackages) {
    if (packages.packages.length === 0) {
      return Promise.resolve(true);
    }
    if (packages.deletedPackages.length > 0) {
      packages.deletedPackages.forEach((p) => {
        this.deletePersonalPackage(p);
      });
    }
    packages.packages.forEach(async (p) => {
      // console.log(p);

      if (!p.deleted) {
        await this.savePersonalPackage(p);
      } else {
        this.deletePersonalPackage(p._id);
      }
    });
  }
  public async savePersonalPackage(
    personalPackage: Perosnlapackages
  ): Promise<boolean> {
    const fls = await this.dbService.getByIndex(
      'personalPackage',
      '_id',
      personalPackage._id
    );
    let response = true;
    if (fls) {
      const ids: string[] = personalPackage.foods.map(
        (ids) => ids.food as string
      );

      await this.dietApiService.getFoods(ids, false).then(async (f) => {
        const data = f.getData().getFoods();
        data.map((res, i) => {
          data.findIndex((v) => v._id === res._id);

          personalPackage.foods[i].food = f.getData().getFoods()[i];
          (personalPackage.foods[i].food as FoodModel).foodFactModel =
            this.makeFoodFactsModel(
              new FoodFactCreate(
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.calorieAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.proteinAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.carbohydrateAmount,
                (personalPackage.foods[i].food as FoodModel).foodFact.fatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.sugarAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.fiberAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.sodiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.potassiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.calciumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.magnesiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.phosphorAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.ironAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.saturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.polyunsaturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.monounsaturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.transFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.cholesterolAmount
              )
            );
        });
        response = response = await this.dbService
          .update('personalPackage', {
            id: fls['id'],
            _id: personalPackage._id,
            foods: personalPackage.foods,
            title: personalPackage.title,
            user: personalPackage.user,
          })
          .then(
            () => {
              return true;
            },
            (error) => {
              console.log(error);
              return false;
            }
          );
      });
    } else {
      const ids: string[] = personalPackage.foods.map(
        (ids) => ids.food as string
      );

      await this.dietApiService.getFoods(ids, false).then(async (f) => {
        const data = f.getData().getFoods();
        data.map((res, i) => {
          data.findIndex((v) => v._id === res._id);

          personalPackage.foods[i].food = f.getData().getFoods()[i];
          (personalPackage.foods[i].food as FoodModel).foodFactModel =
            this.makeFoodFactsModel(
              new FoodFactCreate(
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.calorieAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.proteinAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.carbohydrateAmount,
                (personalPackage.foods[i].food as FoodModel).foodFact.fatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.sugarAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.fiberAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.sodiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.potassiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.calciumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.magnesiumAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.phosphorAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.ironAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.saturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.polyunsaturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.monounsaturatedFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.transFatAmount,
                (
                  personalPackage.foods[i].food as FoodModel
                ).foodFact.cholesterolAmount
              )
            );
        });
        response = await this.dbService
          .add('personalPackage', {
            _id: personalPackage._id,
            foods: personalPackage.foods,
            title: personalPackage.title,
            user: personalPackage.user,
          })
          .then(
            () => {
              return true;
            },
            (error) => {
              console.log(error);
              return false;
            }
          );
      });
    }
    return Promise.resolve(response);
  }

  public async getAllPersonalPackageLogs(): Promise<Perosnlapackages[]> {
    let personalPackage: Perosnlapackages[] = [];
    const data = this.dbService.getAll('personalPackage').then((fls) => {
      personalPackage = [];
      fls.forEach((food) => {
        const d = new Perosnlapackages(
          food['deleted'],
          food['_id'],
          food['title'],
          food['foods'],
          food['user']
        );
        personalPackage.push(d);
      });
      return personalPackage;
    });

    return Promise.resolve(data);
  }
  public async deletePersonalPackage(id: string): Promise<boolean> {
    const fls = await this.dbService.getByIndex('personalPackage', '_id', id);

    let response;
    if (fls) {
      response = this.dbService.delete('personalPackage', fls.id).then(
        () => {
          return true;
        },
        (error) => {
          console.log(error);
          return false;
        }
      );
    } else {
      response = false;
    }
    return response;
  }
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
}
